<script lang="ts" setup>
import {useModalsStore} from "@/stores/modals";
import RequisiteItem, {type TRequisite} from "@/components/profile/RequisiteItem.vue";
import {onMounted, onUnmounted, ref} from "vue";

type TProps = {
  requisites: TRequisite[]
}

const requisites = ref<TRequisite[]>([])
const modalStore = useModalsStore()

const props = defineProps<TProps>()

const updateRequisitesHandler = (e: unknown | CustomEvent) => {
  requisites.value = (e as CustomEvent).detail
}

onMounted(() => {
  requisites.value = props.requisites

  window.addEventListener('requisitesUpdate', updateRequisitesHandler)
})

onUnmounted(() => {
  window.removeEventListener('requisitesUpdate', updateRequisitesHandler)
})
</script>

<template>
  <div v-if="requisites.length" class="col-span-10 flex flex-col desktop:grid grid-cols-3 gap-5">
    <RequisiteItem v-for="requisite in requisites" :key="requisite.id" :requisite="requisite"/>
    <button aria-controls="radix-:r33:" aria-expanded="false" aria-haspopup="dialog" class="inline-flex items-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 font-myriadPro justify-center text-xl border rounded-none font-normal hover:bg-[hsl(var(--roke-text-blue))] hover:text-[hsl(var(--roke-white))] h-[3.75rem] px-2.5 mt-[1.25rem] col-span-3 w-full" data-state="closed" type="button" @click="modalStore.showRequisitesModal()">Добавить новые реквизиты</button>
  </div>
  <div v-else>
    <div class="flex flex-col w-full max-w-[27.688rem] mx-auto"><p class="text-[2.5rem] leading-[90%]">Реквизиты не добавлены </p>
      <span class="mt-[1.875rem]">У вас пока нет сохраненных реквизитов. Добавьте данные — это ускорит оформление заказа.</span>
      <button aria-controls="radix-:r1v:" aria-expanded="false" aria-haspopup="dialog" class="inline-flex items-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 font-myriadPro justify-center text-xl border w-fit rounded-none font-normal hover:bg-[hsl(var(--roke-text-blue))] hover:text-[hsl(var(--roke-white))] min-h-[2.5rem] px-2.5 mt-[1.25rem]" data-state="closed" type="button" @click="modalStore.showRequisitesModal()">Добавить новые реквизиты</button>
    </div>
  </div>
</template>